import { render } from "./PublicationFeatures.vue.js?vue&type=template&id=c4bafd60!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeatures.vue?vue&type=template&id=c4bafd60"
import script from "./PublicationFeatures.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeatures.vue?vue&type=script&lang=js"
export * from "./PublicationFeatures.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationFeatures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4bafd60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4bafd60', __exports__)) {
    api.reload('c4bafd60', __exports__)
  }
  
  module.hot.accept("./PublicationFeatures.vue.js?vue&type=template&id=c4bafd60!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeatures.vue?vue&type=template&id=c4bafd60", () => {
    api.rerender('c4bafd60', render)
  })

}


export default __exports__